import store from "./redux/store";
import {setLoggedIn} from "./redux/listsSlice";
import { forceLogout, license } from './serverREST';
import {setOpenTooManySessions} from "./redux/licenseSlice";
import {getEndpointUrl} from './utils/endpointUrl';
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";

const wsMsgUnauthorized = '401';
const wsMsgTooManyClients = '418';
const wsMsgLicenseEnded = '410';
const wsMsgPing = 'ping';
const wsMsgPong = 'pong';

const wsReconnectTimeOut = 10000; // 10s

function getWebSocketUrl() {
    let url = getEndpointUrl(process.env.REACT_APP_WS ?? '');
    url = url.replace('https://', 'wss://').replace('http://', 'ws://');
    return url;
}

let socket = null;
let reconnectTimeout = null;

const onOpen = () => {
   // console.info('WS: Connected');
};

const onSuddenClose = () => {
    clearTimeout(reconnectTimeout);

    const isLoggedIn = store.getState().lists.loggedIn;
    if (isLoggedIn) {
        console.warn(`WS: Connection broken, reconnect in ${wsReconnectTimeOut / 1000} s`);
        reconnectTimeout = setTimeout(openSocket, wsReconnectTimeOut); // отложенный re-connect
    }
};

const onMessage = ({ data }) => {
    switch (data) {
        case wsMsgUnauthorized:
            console.log('WS: Unauthorized');
            forceLogout(403);
            break;
        case wsMsgTooManyClients:
            console.log('WS: Too many clients');
            store.dispatch(setLoggedIn(false));
            store.dispatch(setOpenTooManySessions(true));
            break;
        case wsMsgLicenseEnded:
            console.log('WS: License ended');
            license(() => { });
            break;
        case wsMsgPing:
            if (socket && socket.readyState === WebSocket.OPEN) {
                socket.send(wsMsgPong);
            }
            break;
        default:
            console.log('WS: unknown message:', data);
    }
};

const openSocket = () => {
    const url = getWebSocketUrl();
    try {
        socket = new WebSocket(url);
    } catch (error) {
        console.error(`WS: Connect Failed (${url})`, error);
        return;
    }

    socket.addEventListener('open', onOpen);
    socket.addEventListener('message', onMessage);
    socket.addEventListener('close', onSuddenClose);
};

const closeSocket = () => {
    console.warn('WS: Closed');
    clearTimeout(reconnectTimeout);
    socket.removeEventListener('close', onSuddenClose);
    if (socket) {
        socket.close();
    }
};

const onBeforeUnload = () => closeSocket();

export function WebSocketMount() {
    const loggedIn = useSelector(state => state.lists.loggedIn);

    useEffect(() => {
        if (loggedIn) {
            openSocket();
            window.addEventListener('beforeunload', onBeforeUnload);
        } else {
            closeSocket();
        }
        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            closeSocket();
        };
    }, [loggedIn]);

    return <React.Fragment />;
}
